import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void) => {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

/**
 * Connectivity as a subscription: nothing re-renders on a bare `navigator.onLine`, so a
 * panel reading it directly keeps its offline copy until something else repaints it.
 */
const useIsOnline = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  )

export default useIsOnline
